// External libraries
import React from 'react';
import { func, object } from 'prop-types';
import { useStoreState } from '@/store';
// @ts-expect-error untyped-import
import { FloatingLabelInput } from '@checkout/react-components';

// Internal modules
import { features, getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
// @ts-expect-error untyped-import
import { blurHandler, changeHandler, focusHandler } from './handlers';
import { getValidationProps, validationFunctionMap } from './validation';
import { getNationalityBasedKycValue } from '@/lib/features/utils';
import type { GenericObjectType } from '@/types';

export type IdentityDocumentNumberProps = {
  blurHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  nationality?: GenericObjectType;
};

const IdentityDocumentNumber = (
  props: IdentityDocumentNumberProps,
): JSX.Element => {
  useMountLogging('IdentityDocumentNumber');
  const identityDocumentNumber = useStoreState(
    ({ form }) => form.identityDocumentNumber,
  );
  const identityDocumentType = useStoreState(
    ({ form }) => form.identityDocumentType?.value,
  );
  const nationality = useStoreState(({ form }) => form.nationality) || {};
  const labelContentKey = getNationalityBasedKycValue(
    features.config.kycIdentityDocumentNumberLabelKey,
    // @ts-expect-error don't use default object
    nationality?.value,
  );

  const label = getContent(labelContentKey);
  // @ts-expect-error check for undefined
  const { maxLength, pattern } = getValidationProps(identityDocumentType);

  return (
    <FloatingLabelInput
      blurHandler={blurHandler}
      changeHandler={changeHandler}
      focusHandler={focusHandler}
      id="identityDocumentNumber"
      label={label}
      // regex and maxLength for current country identityDocumentTypes
      maxLength={maxLength}
      pattern={pattern}
      required={true}
      // validationFn defaults to generic validation if null
      // @ts-expect-error TODO this worked pre typescript
      validationFn={validationFunctionMap[identityDocumentType]}
      {...identityDocumentNumber}
    />
  );
};

IdentityDocumentNumber.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
  nationality: object,
};

export { IdentityDocumentNumber };
